import React, { useEffect, useState } from 'react';
import './styles.css';
import FileViewer from 'react-file-viewer';

function Viewfiles({ setView, fileSelected })
{

	const [ fileType, setFileType ] = useState('');
	const [ fileUrl, setFileUrl ] = useState('');

	const handleClose = () =>
	{
		setView(false);
	};

	useEffect(() =>
	{
		if (fileSelected)
		{
			const fileExtension = fileSelected.name.split('.').pop()
				.toLowerCase();

			setFileType(fileExtension);
			setFileUrl(fileSelected.url);
		}
	}, [ fileSelected ]);

	return (
		<div className='flexCol viewFileBD fullH '>
			<div className='flexCol viewFile jCntr aCntr jBtwn'>
				<div className='flexRow pdngSM aEnd jBtwn'>
					<span className='pdfHding'>{fileSelected?.name}</span>
					<img
						onClick={handleClose}
						src='/images/cancel.svg'
						alt='cancel'
						className='IconImage  pointer'
					/>
				</div>
				<div className='flexCol pdf pdfHg jCntr'>
					{fileType === 'mp4' ? (
						<video width='100%' src={fileUrl} controls autoPlay />
					) : (
						<FileViewer
							fileType={fileType}
							filePath={fileUrl}
						// onError={this.onError}
						/>
					)}
				</div>
			</div>
		</div>
	);
}

export default Viewfiles;
